import { render } from "./sourcemap.vue?vue&type=template&id=842fa2b8"
import script from "./sourcemap.vue?vue&type=script&lang=js"
export * from "./sourcemap.vue?vue&type=script&lang=js"

import exportComponent from "/home/minify-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__